import { render, staticRenderFns } from "./cartoon.vue?vue&type=template&id=3f6ca448&scoped=true&"
import script from "./cartoon.vue?vue&type=script&lang=js&"
export * from "./cartoon.vue?vue&type=script&lang=js&"
import style0 from "./cartoon.vue?vue&type=style&index=0&id=3f6ca448&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6ca448",
  null
  
)

export default component.exports